// @ts-check
/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-this-alias */

import * as uuid from 'uuid';

/**
 * RcmEventManager
 *
 * @constructor
 */
const RcmEventManager = function () {
  const self = this;

  /**
   * events
   *
   * @type {{}}
   */
  const events = {};

  /**
   * promises
   *
   * @type {{}}
   */
  const promises = {};

  /**
   * on - register listener
   *
   * @param {string} event
   * @param {function} method - If the method returns false, it will stop the event stack
   * @param {string} [id] - Can specify an even id so only on listener will be registered
   * @param {boolean} [checkPromise] - Defaults to true. Calls listener immediately if the event has already fired
   * @returns {string} evnet id
   */
  self.on = function (event, method, id, checkPromise) {
    if (!events[event]) {
      events[event] = {};
    }

    if (typeof id === 'undefined' || id === null || id === '') {
      id = uuid.v4();
    }

    events[event][id] = method;

    // checkPromise defaults to true
    if (checkPromise || typeof checkPromise === 'undefined') {
      honorPromise(event, method);
    }

    return id;
  };

  /**
   * remove listener
   *
   * @param event
   * @param id
   */
  self.remove = function (event, id) {
    if (!events[event]) {
      return;
    }

    events[event][id] = undefined;

    try {
      delete events[event][id];
    } catch (e) {}
  };

  /**
   * trigger listener
   *
   * @param event
   * @param args
   */
  self.trigger = function (event, args) {
    self.onTrigger(event, args);

    if (events[event]) {
      const listeners = events[event];

      for (const key in listeners) {
        if (!listeners.hasOwnProperty(key)) continue;

        const value = listeners[key];

        if (typeof value === 'function') {
          const continueEvents = value(args);
          // If a callback returns false, we break the event stack
          if (continueEvents === false) {
            return false;
          }
        }
      }
    }

    makePromise(event, args);
  };

  self.onTrigger = function (event, args) {
    // overridable debug method
  };

  /**
   * makePromise
   *
   * @param event
   * @param args
   */
  var makePromise = function (event, args) {
    promises[event] = args;
  };

  /**
   * honorPromise
   *
   * @param event
   * @param method
   */
  var honorPromise = function (event, method) {
    if (promises[event]) {
      method(promises[event]);
    }
  };

  /**
   * hasEvent
   *
   * @param event
   * @param id
   * @returns {boolean}
   */
  self.hasEvent = function (event, id) {
    if (!events[event]) {
      return false;
    }

    if (!events[event][id]) {
      return false;
    }

    return typeof events[event][id] === 'function';
  };

  /**
   *
   * @param event
   * @returns {boolean}
   */
  self.hasEvents = function (event) {
    if (!events[event]) {
      return false;
    }

    const listeners = events[event];

    for (const key in listeners) {
      if (!listeners.hasOwnProperty(key)) continue;

      const value = listeners[key];

      if (typeof value === 'function') {
        return true;
      }
    }

    return false;
  };
};

window.RcmEventManager = RcmEventManager;

export default RcmEventManager;
